import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { cn } from "@omni/utils/styles";

import { useProductResultsContext } from "../../../../context/productResults.context";

type BaseProps = RequireChildrenFor<{}>;

const Base = ({ children }: BaseProps) => {
    const { filtersRef } = useProductResultsContext();
    return (
        <div
            ref={filtersRef}
            className={cn(
                "tw:grid tw:grid-cols-[1fr_1fr] tw:gap-5 tw:justify-between tw:items-stretch tw:pb-2",
                "tw:sm:flex tw:sm:grid-cols-none tw:sm:gap-0",
                "tw:md:justify-end"
            )}
        >
            {children}
        </div>
    );
};

export { Base };
